import React from 'react';
import {Table, Button, Input} from 'antd';
import Info from '../Detail/Info';

class SliderSelect extends React.Component {
    constructor(props) {
        super();
    }

    columns = [
        {
            title:"图片",
            dataIndex:"image",
            render:(photo, record)=>{
                return <Info style={{width:80,height:80}} showProgress={false} useLabel={false} type="upload" value={photo} onChange={this.setKeyValue.bind(this, record, 'image')} />;
            }
        },
        {
            title:"链接",
            dataIndex:"url",
            render:(intro, record)=>{
                return <Info type="text" value={intro} useLabel={false} onChange={this.setKeyValue.bind(this, record, 'url')} />;
            }
        },
        {
            title:"操作",
            render:(field, record, index)=>{
                return <a  onClick={()=>this.deleteHandler(index)}>删除</a>;
            }
        }
    ];

    setKeyValue(record, key, val) {
        let {onChange, value} = this.props;

        var target = value.find(it=>it.index == record.index);
        target[key] = val;

        onChange(value);
    }

    deleteHandler = (index)=>{
        let {onChange, value} = this.props;

        value = value instanceof Array ? value : [];
        if(value[index]) {
            value.splice(index, 1);
        }

        onChange(value);
    }

    addOne = ()=>{
        let {onChange, value} = this.props;
        value = value instanceof Array ? value : [];
        value.push({
            index:value[value.length - 1] ? value[value.length - 1].index + 1 : 1,
            image:"",
            url:""
        });

        onChange(value);
    }

    render() {
        let {value, record} = this.props;
        value = value instanceof Array ? value : [];

        return <div className="guestlist">
            <p className="required">* 图片尺寸建议为 750x420，请勿必所有图片保持同一尺寸</p>
            <Table columns={this.columns}
                dataSource={value}
                rowKey={"index"}
                footer={()=>(<a  onClick={this.addOne}>添加一行</a>)}
            />
            <div style={{marginTop:10}}>
                {record.background ? <div><img alt="" src={'//image1.jfoto.cn/' + record.background + '!avatar_150'} /><p className="required">以前的封面图片</p></div> : null}
            </div>
        </div>;
    }
}

export default SliderSelect;



// WEBPACK FOOTER //
// ./src/components/Select/SliderSelect.js